module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/crypto.js
// module id = 486
// module chunks = 0